var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserHelmetSafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176 60.8c-28.7 16.6-48 47.6-48 83.2l192 0c0-35.5-19.3-66.6-48-83.2L272 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-19.2zM271.2 25C318.5 43.8 352 90 352 144l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 176c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c0-54 33.5-100.2 80.8-119C180 10.7 192.7 0 208 0l32 0c15.3 0 28 10.7 31.2 25zM224 320c-65.3 0-119.1-48.9-127-112l32.3 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80l32.3 0c-7.9 63.1-61.7 112-127 112zM415.8 480c-3.3-53.6-47.8-96-102.2-96l-179.2 0C80 384 35.5 426.4 32.2 480l383.6 0zM0 486.4C0 412.2 60.2 352 134.4 352l89.6 0 89.6 0C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserHelmetSafety);
export default __webpack_public_path__ + "static/media/user-helmet-safety.cfd6fdc102a76304738eae2bd559d7e1.svg";
export { ForwardRef as ReactComponent };